import { PendingNavigateCallback } from '../types/PendingNavigateCallback';

export const pendingNavigateCallbacks = new Set<PendingNavigateCallback>();
